var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import WalletController from "./WalletController";
import Loading from "./Loading";
import getEndpoint from "../helpers/getEndpoint";
import { captureException, captureMessage } from "@sentry/react";
var WalletConnect = function () {
    var _a = useState(undefined), customerId = _a[0], setCustomerId = _a[1];
    var _b = useState(false), initialCheckComplete = _b[0], setInitialCheckComplete = _b[1];
    var _c = useState(undefined), customerWalletAddress = _c[0], setCustomerWalletAddress = _c[1];
    // needed to store wallet address as disconnect clears customerWalletAddress
    var _d = useState(undefined), addressForDisconnect = _d[0], setAddressForDisconnect = _d[1];
    var _e = useState(false), userConfirmedWalletAddress = _e[0], setUserConfirmedWalletAddress = _e[1];
    var _f = useState(false), cloudKeyAtAddressChecked = _f[0], setCloudKeyAtAddressChecked = _f[1];
    var _g = useState(undefined), signedMessage = _g[0], setSignedMessage = _g[1];
    var _h = useState(undefined), userTokens = _h[0], setUserTokens = _h[1];
    var _j = useState(true), loading = _j[0], setLoading = _j[1];
    var _k = useState(false), noKeysFound = _k[0], setNoKeysFound = _k[1];
    var _l = useState(false), settingNewWalletAddress = _l[0], setSettingNewWalletAddress = _l[1];
    var _m = useState(false), walletConnected = _m[0], setWalletConnected = _m[1];
    var _o = useState(false), firstConnect = _o[0], setFirstConnect = _o[1];
    var _p = useState(false), disconnectedWallet = _p[0], setDisconnectedWallet = _p[1];
    var _q = useState(false), loadingState = _q[0], setLoadingState = _q[1];
    var _r = useState(0), expiry = _r[0], setExpiry = _r[1];
    var connection = JSON.parse(sessionStorage.getItem("connected"));
    var firstConnection = JSON.parse(sessionStorage.getItem("firstConnect"));
    var sentThroughId = document.getElementById("customerId").textContent;
    // initial useEffect that checks if the user has a walletAddress in their shopify metafields
    useEffect(function () {
        var getUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
            var currentCustomerId, serverURL, userDetails, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        currentCustomerId = document.getElementById("customerId").textContent;
                        setCustomerId(currentCustomerId);
                        serverURL = getEndpoint("getCustomerWalletAddress", "customerId=".concat(currentCustomerId));
                        return [4 /*yield*/, axios.get(serverURL)];
                    case 1:
                        userDetails = _a.sent();
                        if (userDetails.data.result.value) {
                            setCustomerWalletAddress(userDetails.data.result.value);
                            setAddressForDisconnect(userDetails.data.result.value);
                            setWalletConnected(true);
                            setFirstConnect(true);
                            sessionStorage.setItem("firstConnect", "true");
                            sessionStorage.setItem("connected", "true");
                        }
                        setInitialCheckComplete(true);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1);
                        captureException(err_1);
                        return [3 /*break*/, 3];
                    case 3:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (!initialCheckComplete && !customerWalletAddress && !firstConnect) {
            if (connection === false && firstConnection === true) {
                setLoading(false);
                return;
            }
            getUserInfo();
        }
    }, []);
    // verifies that the users connected wallet has a cloudkey in it
    // performs checks for empty wallets, re-connecting the same wallet
    useEffect(function () {
        var verifyUserHasCloudKey = function () { return __awaiter(void 0, void 0, void 0, function () {
            var serverURL, doesWalletHaveCloudKey, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        serverURL = getEndpoint("getTokensAtWalletAddress", "walletAddress=".concat(customerWalletAddress));
                        return [4 /*yield*/, axios.get(serverURL)];
                    case 1:
                        doesWalletHaveCloudKey = _a.sent();
                        if (doesWalletHaveCloudKey.data.result &&
                            doesWalletHaveCloudKey.data.result.length > 0) {
                            setUserTokens(doesWalletHaveCloudKey.data.result);
                            // settings for disabling loading spinner and edge cases
                            setSettingNewWalletAddress(false);
                            setDisconnectedWallet(false);
                            setNoKeysFound(false);
                        }
                        else {
                            setUserTokens([]);
                            setNoKeysFound(true);
                            setSettingNewWalletAddress(false);
                            setLoading(false);
                            captureMessage("No keys retrieved for ".concat(customerWalletAddress));
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _a.sent();
                        setUserTokens([]);
                        captureException(err_2);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        setCloudKeyAtAddressChecked(true);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        if (customerWalletAddress) {
            verifyUserHasCloudKey();
        }
    }, [
        customerWalletAddress,
        cloudKeyAtAddressChecked,
        settingNewWalletAddress,
    ]);
    // the useEffect that is fired when the user signs a message from their connected wallet
    useEffect(function () {
        var registerUserWallet = function () { return __awaiter(void 0, void 0, void 0, function () {
            var serverURL, retrievedCustomerWalletAddress, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        serverURL = getEndpoint("updateCustomer", "customerId=".concat(sentThroughId, "&walletAddress=").concat(customerWalletAddress, "&signedMessage=").concat(signedMessage, "&expiry=").concat(expiry));
                        return [4 /*yield*/, axios.post(serverURL)];
                    case 1:
                        retrievedCustomerWalletAddress = _a.sent();
                        setSignedMessage(retrievedCustomerWalletAddress.data.signedMessage);
                        setUserConfirmedWalletAddress(true);
                        return [3 /*break*/, 4];
                    case 2:
                        err_3 = _a.sent();
                        console.log(err_3);
                        captureException(err_3);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        if (signedMessage) {
            setLoading(true);
            registerUserWallet();
        }
    }, [
        signedMessage,
        setSignedMessage,
        userConfirmedWalletAddress,
        setUserConfirmedWalletAddress,
    ]);
    // this useEffect is fired when users disconnect their wallet, and the customer metafields are updated
    useEffect(function () {
        var removeUserWallet = function () { return __awaiter(void 0, void 0, void 0, function () {
            var serverURL, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        serverURL = getEndpoint("resetCustomerWalletAddress", "customerId=".concat(sentThroughId, "&walletAddress=").concat(addressForDisconnect));
                        return [4 /*yield*/, axios.post(serverURL)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        console.log(err_4);
                        captureException(err_4);
                        return [3 /*break*/, 3];
                    case 3:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (disconnectedWallet) {
            setLoading(true);
            removeUserWallet();
        }
    }, [disconnectedWallet]);
    // checking for when users are changing wallets
    var switchingWallet = function (isSwitching) {
        if (isSwitching) {
            setSettingNewWalletAddress(true);
            setUserTokens([]);
        }
        else {
            setSettingNewWalletAddress(false);
        }
    };
    // needed to manage the loading state and displayed spinner
    var loadingStateSetter = function (loadingState) {
        if (loadingState) {
            setLoadingState(true);
        }
    };
    // handles state management around wallet connection
    var connectedWallet = function (connected) {
        if (connected) {
            setWalletConnected(true);
        }
        else {
            setWalletConnected(false);
            setDisconnectedWallet(true);
            setUserTokens([]);
        }
    };
    return (React.createElement(React.Fragment, null,
        loading && React.createElement(Loading, null),
        !customerWalletAddress && !loading && (React.createElement("p", null, "No wallet connected, please connect a valid wallet.")),
        !loading && customerWalletAddress && (React.createElement("p", null,
            "The Wallet Address in your connected wallet is:",
            " ",
            customerWalletAddress)),
        !userTokens && customerWalletAddress && React.createElement(Loading, null),
        !loading &&
            userTokens &&
            userTokens.length > 0 &&
            customerWalletAddress && (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "CloudKey", "".concat(userTokens.length > 1 ? "s" : ""),
                " in your connected Wallet:"),
            " ",
            React.createElement("table", { className: "AccountTable Table Table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { style: { paddingLeft: "2px", fontWeight: "bolder" } }, "CloudKey #"),
                        React.createElement("th", { style: { fontWeight: "bolder" } }, "Explorer Link"))),
                React.createElement("tbody", null, userTokens.map(function (item) {
                    return (React.createElement("tr", { key: item },
                        React.createElement("td", { style: { paddingLeft: "2px" } }, item),
                        React.createElement("td", null,
                            React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://mumbai.polygonscan.com/token/".concat(customerWalletAddress, "?a=").concat(item) }, "View on Explorer \u2197"))));
                }))))),
        settingNewWalletAddress && (React.createElement(React.Fragment, null,
            React.createElement(Loading, null))),
        disconnectedWallet && loadingState && React.createElement(Loading, null),
        !loading &&
            customerWalletAddress &&
            !disconnectedWallet &&
            noKeysFound && (React.createElement("p", { style: { fontWeight: "bolder" } }, "No CloudKeys in this wallet. Please connect a valid wallet!")),
        !loading && (React.createElement(WalletController, { setUserWalletAddress: setCustomerWalletAddress, isCloudKeyHolder: true, setSignedMessage: setSignedMessage, customerWalletAddress: customerWalletAddress, switchingWallet: switchingWallet, connectedWallet: connectedWallet, loadingStateSetter: loadingStateSetter, customerId: customerId, setExpiry: setExpiry }))));
};
export { WalletConnect };
